import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot} from '@angular/router';
import { Observable } from 'rxjs';

import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';

@Injectable({ providedIn: 'root'})
export class AgenteFinanceiroResolver implements Resolve<Observable<AgenteFinanceiro[]>> {

    constructor(
         private agenteService: AgenteFinanceiroService
    ) {}

    resolve(route: ActivatedRouteSnapshot
        ): Observable<AgenteFinanceiro[]>  {
        return this.agenteService.getAgentesFinanceirosNestaModalidade(route.data.refreshAgentes);
    }
}
